import React from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import Modal from "./Modal";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import { API_DOMAIN_URL } from "../Common";

export function MemberInfoAddMode({
  orgUser,
  updateOwnedMembers,
  setDisplayMode,
}) {
  //console.log(updateOwnedMembers);

  // Validationスキーマの定義
  const validationSchema = Yup.object().shape({
    NickName: Yup.string().required("表示名を入力してください").max(100, "表示名は100文字以内で入力してください"),
    Furigana: Yup.string().required("ふりがなを入力してください").max(100, "ふりがなは100文字以内で入力してください").matches(/^[ぁ-ん\u3000 ー]+$/, "ふりがなはひらがなで入力してください"),
    Sex: Yup.number().required("性別を入力してください"),
    Birthday: Yup.string().required("誕生日を入力してください").test("min-age", "誕生日は3年以上前の日付を入力してください", (v) => {
      if (!v) return true;
      const date = new Date(v);
      if (isNaN(date.getTime())) return true;
      const threshold = new Date();
      threshold.setFullYear(threshold.getFullYear() - 3);
      return date <= threshold;
    }),
    BodyHeight: Yup.number().transform((cv) => (isNaN(cv) ? undefined : cv)).required("身長を入力してください").min(1, "身長は0より大きい値を入力してください"),
    BodyWeight: Yup.number().transform((cv) => (isNaN(cv) ? undefined : cv)),
    Prefecture: Yup.string().nullable().notRequired(),

    CareLevel: Yup.number().nullable().notRequired(),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = (data) => {
    if (
      data.NickName == undefined ||
      data.Furigana == undefined ||
      data.Sex == undefined ||
      data.Birthday == undefined
    ) {
      console.log("Invalid Input Value");
      return;
    }

    let addingMember = {};
    addingMember.UserName = data.NickName;
    addingMember.NickName = data.NickName;
    addingMember.Furigana = data.Furigana;
    addingMember.Sex = data.Sex;
    addingMember.Birthday = data.Birthday;
    addingMember.BodyHeight = data.BodyHeight;
    addingMember.BodyWeight = data.BodyWeight;
    addingMember.Prefecture = data.Prefecture;

    addingMember.CareLevel = data.CareLevel;
    addingMember.SampleGroupId = orgUser.SampleGroupId;
    addingMember.CreateUserId = orgUser.id;

    //updateMember(editedMember);
    addSubMember(addingMember);
  };

  const addSubMember = (addingMember) => {
    if (!addingMember) {
      return;
    }

    // update db
    const bodyString = JSON.stringify(addingMember);

    const code = process.env.REACT_APP_API_CODE;
    let url = API_DOMAIN_URL + `/api/CreateSubMember?code=${code}`;
    //console.log(url);

    fetch(url, {
      method: "POST",
      body: bodyString,
    }).then(
      function (response) {
        //console.log(response);
        if (response.status == 200) {
          successModalOpen();
        } else if (response.status == 204 || response.status == 400) {
          errorModalOpen();
        }
      },
      function (error) {
        console.log(error);
      }
    );
  };

  // 更新完了確認のモーダル
  const [successModalStatus, setSuccessModalStatus] = React.useState(false);
  const successModalOpen = () => {
    setSuccessModalStatus(true);
  };
  const successModalClose = () => {
    setSuccessModalStatus(false);
    setDisplayMode(2); // 非活性化
    updateOwnedMembers(); // 組織内ユーザーを再取得
  };

  // エラーモーダル
  const [errorModalStatus, setErrorModalStatus] = React.useState(false);
  const errorModalOpen = () => {
    setErrorModalStatus(true);
  };
  const errorModalClose = () => {
    setErrorModalStatus(false);
  };

  const SexChange = (ele) => {
    console.log(ele);
  };

  const CareLevelChange = (ele) => {
    console.log(ele);
  };

  return (
    <>
      <Typography component="h1" variant="h5" sx={{ mt: 3 }}>
        メンバー新規追加
      </Typography>
      <Box
        component="form"
        noValidate
        onSubmit={handleSubmit(onSubmit)}
        sx={{ mt: 5, p: 3, border: "1px solid grey" }}
      >
        <Typography variant="h6" align="center">
          メンバー情報
        </Typography>
        <Grid md={{ flexGrow: 1 }} container spacing="2">
          <Grid item md={12}>
            <Grid container justifyContent="center" spacing={1}>
              <Grid item md={12}>
                <TextField
                  name="NickName"
                  fullWidth
                  required
                  size="small"
                  id="NickName"
                  label="表示名"
                  {...register("NickName")}
                  error={errors.NickName ? true : false}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.NickName?.message}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="center"
              sx={{ mt: "3px" }}
              spacing={1}
            >
              <Grid item md={12}>
                <TextField
                  name="Furigana"
                  required
                  fullWidth
                  size="small"
                  id="Furigana"
                  label="ふりがな"
                  {...register("Furigana")}
                  error={errors.Furigana ? true : false}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.Furigana?.message}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="left"
              sx={{ mt: "3px" }}
              spacing={1}
            >
              <Grid item md={2}>
                <InputLabel id="demo-simple-select-autowidth-label" required>
                  <Typography variant="caption">性別</Typography>
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="Sex"
                  width="30"
                  size="small"
                  label="Sex"
                  defaultValue={1}
                  onChange={(ele) => SexChange(ele)}
                  {...register("Sex")}
                  error={errors.Sex ? true : false}
                >
                  <MenuItem value={1}>男</MenuItem>
                  <MenuItem value={2}>女</MenuItem>
                </Select>
                <Typography variant="inherit" color="textSecondary">
                  {errors.Sex?.message}
                </Typography>
              </Grid>
              <Grid item md={5} sx={{ mt: 3 }}>
                <TextField
                  name="Birthday"
                  required
                  size="small"
                  id="Birthday"
                  label="生年月日 例)1960/01/01"
                  defaultValue={`${new Date().getFullYear()}/${String(new Date().getMonth()+1).padStart(2,'0')}/${String(new Date().getDate()).padStart(2,'0')}`}
                  {...register("Birthday")}
                  error={errors.Birthday ? true : false}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.Birthday?.message}
                </Typography>
              </Grid>
              <Grid item md={5}>
                <InputLabel id="demo-simple-select-autowidth-label">
                  <Typography variant="caption">介護度</Typography>
                </InputLabel>
                <Select
                  labelId="care-level-label"
                  id="CareLevel"
                  width="80"
                  label="介護度"
                  size="small"
                  defaultValue={0}
                  onChange={(ele) => CareLevelChange(ele)}
                  {...register("CareLevel")}
                  error={errors.CareLevel ? true : false}
                >
                  <MenuItem value={0}>&nbsp;</MenuItem>
                  <MenuItem value={1}>要支援１</MenuItem>
                  <MenuItem value={2}>要支援２</MenuItem>
                  <MenuItem value={3}>要介護１</MenuItem>
                  <MenuItem value={4}>要介護２</MenuItem>
                  <MenuItem value={5}>要介護３</MenuItem>
                  <MenuItem value={6}>要介護４</MenuItem>
                  <MenuItem value={7}>要介護５</MenuItem>
                </Select>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="left"
              sx={{ mt: "3px" }}
              spacing={1}
            >
              <Grid item md={6}>
                <TextField
                  name="BodyHeight"
                  required
                  size="small"
                  id="BodyHeight"
                  label="身長(cm)"
                  {...register("BodyHeight")}
                  error={errors.BodyHeight ? true : false}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.BodyHeight?.message}
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  身長は測定値の計算に使用するため必須となります。
                </Typography>
              </Grid>
              <Grid item md={6}>
                <TextField
                  name="BodyWeight"
                  size="small"
                  id="BodyWeight"
                  label="体重(kg)"
                  {...register("BodyWeight")}
                  error={errors.BodyWeight ? true : false}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.BodyWeight?.message}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="left"
              sx={{ mt: "3px" }}
              spacing={1}
            >
              <Grid item md={6}>
                <TextField
                  name="Prefecture"
                  size="small"
                  id="Prefecture"
                  label="都道府県"
                  {...register("Prefecture")}
                  error={errors.Prefecture ? true : false}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.Prefecture?.message}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {/* <Button
          variant="contained"
          color="primary"
          sx={{ mt: 2, width: 100 }}
          type="submit"
          onClick={handleSubmit(onSubmit)}
        >
          追加
        </Button> */}
      </Box>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={8} container justifyContent="right">
          <Button
            variant="contained"
            color="primary"
            sx={{ mt: 2, width: 100 }}
            type="submit"
            onClick={handleSubmit(onSubmit)}
          >
            追加
          </Button>
        </Grid>
        <Grid item xs={2} container justifyContent="center">
          <Button
            variant="contained"
            color="primary"
            sx={{ mt: 2, width: 120 }}
            onClick={() => setDisplayMode(2)}
          >
            キャンセル
          </Button>
        </Grid>
      </Grid>
      <Modal
        title={"登録失敗"}
        message={"メンバーの登録に失敗しました"}
        status={errorModalStatus}
        okBtnCallback={errorModalClose}
      />
      <Modal
        title={"登録成功"}
        message={"メンバーの登録が完了しました"}
        status={successModalStatus}
        okBtnCallback={successModalClose}
      />
    </>
  );
}

MemberInfoAddMode.propTypes = {
  orgUser: PropTypes.object,
  setDisplayMode: PropTypes.number,
  updateOwnedMembers: PropTypes.any,
};
